function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-27.816 -.90832)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-28.972 -56.792)",
  opacity: 0.999
}, /*#__PURE__*/React.createElement("circle", {
  transform: "translate(28.972 56.792)",
  cx: 40.661,
  cy: 13.753,
  r: 12.844,
  fill: "rgba(0, 0, 0, 0.85)",
  fillOpacity: 0.98824,
  fillRule: "evenodd",
  opacity: 0.8
}), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -65.975 -64.356)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#404040"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#404040"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#a9671a"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v0.99981l1.1012 1e-6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m69.636 77.656v0.99981l-1.1012 1e-6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v0.99981l-1.1012 1e-6z"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -68.154 -66.151)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#db8621"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#c87a1e"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -63.796 -66.151)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#c87a1e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#db8621"
})), /*#__PURE__*/React.createElement("path", {
  d: "m69.633 71.441v3.5899l2.1789-1.7953z",
  fill: "#c87a1e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m69.633 71.441v3.5899l-2.1789-1.7953z",
  fill: "#c87a1e"
}), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -61.617 -75.126)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#ddd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#c87a1e"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -70.333 -75.125)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#c87a1e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#ddd"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -72.512 -76.92)",
  fill: "#424242"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#424242"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1.9787 0 0 1.7949 211.78 -76.92)",
  fill: "#424242"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#424242"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -65.975 -71.536)",
  fill: "#db8621"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -68.154 -69.741)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#db8621"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#a9671a"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -63.796 -69.741)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#a9671a"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#db8621"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -63.796 -73.33)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#c87a1e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#a9671a"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -68.154 -73.33)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#a9671a"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#c87a1e"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -70.916 -70.425)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m67.729 78.037v2l1.1012-1.0002z",
  fill: "#a9671a"
}), /*#__PURE__*/React.createElement("path", {
  d: "m67.729 78.037v2l-1.1012-1.0002z",
  fill: "#a7a7a7"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -59.438 -69.741)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#a7a7a7"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#a9671a"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -70.333 -71.536)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#db8621"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#a9671a"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -61.617 -71.536)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#a9671a"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#db8621"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -59.438 -73.331)",
  fill: "#c87a1e"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m61.928 77.657v2l1.1012-1.0002z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -70.333 -67.946)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#c87a1e",
  opacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#db8621"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -61.617 -67.946)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#db8621"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#c87a1e",
  opacity: 1
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m65.275 71.441 2.1789 1.7946-0.0029-1.7946z",
  fill: "#404040",
  opacity: 0.8
}), /*#__PURE__*/React.createElement("path", {
  d: "m73.991 71.441-2.1789 1.7946 0.0029-1.7946z",
  fill: "#404040",
  opacity: 0.8
}), /*#__PURE__*/React.createElement("path", {
  d: "m65.275 75.031 2.1789 1.7946-2.1789-2e-6z",
  fill: "#ddd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m73.991 75.031-2.1789 1.7946 2.1789-2e-6z",
  fill: "#ddd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m76.17 73.236-2.1789 1.7946 2.1789-2e-6z",
  fill: "#c87a1e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m63.096 73.236 2.1789 1.7946-2.1789-2e-6z",
  fill: "#c87a1e"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#ddd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m63.096 75.031 2.1789 1.7953v-1.7946z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m65.275 76.825 2.1789 1.7953v-1.7946z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m76.17 75.03-2.1789 1.7953v-1.7946z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m73.991 76.825-2.1789 1.7953v-1.7946z"
})), /*#__PURE__*/React.createElement("path", {
  d: "m67.454 76.825 7e-6 1.7953h2.1789z",
  fill: "#a7a7a7"
}), /*#__PURE__*/React.createElement("path", {
  d: "m71.812 76.825-7e-6 1.7953h-2.1789z",
  fill: "#a7a7a7"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#ddd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m78.349 73.235-2.1789 1.7953v-1.7946z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m60.917 73.235 2.1789 1.7953v-1.7946z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m76.17 73.236 2.1789-6.83e-4 -9e-6 -1.7946z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m63.096 73.236-2.1789-6.83e-4 1e-5 -1.7946z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -65.975 -64.356)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#404040"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#404040"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#a9671a"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v0.99981l1.1012 1e-6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m69.636 77.656v0.99981l-1.1012 1e-6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v0.99981l-1.1012 1e-6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v0.99981l1.1012 1e-6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v0.99981l-1.1012 1e-6z"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -68.154 -66.151)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#db8621"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#c87a1e"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -63.796 -66.151)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#c87a1e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#db8621"
})), /*#__PURE__*/React.createElement("path", {
  d: "m69.633 71.441v3.5899l2.1789-1.7953z",
  fill: "#c87a1e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m69.633 71.441v3.5899l-2.1789-1.7953z",
  fill: "#c87a1e"
}), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -61.617 -75.126)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#ddd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#c87a1e"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -70.333 -75.125)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#c87a1e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#ddd"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -72.512 -76.92)",
  fill: "#424242"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#424242"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1.9787 0 0 1.7949 211.78 -76.92)",
  fill: "#424242"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#424242"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -65.975 -71.536)",
  fill: "#db8621"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -68.154 -69.741)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#db8621"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#a9671a"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -63.796 -69.741)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#a9671a"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#db8621"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -63.796 -73.33)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#c87a1e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#a9671a"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -68.154 -73.33)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#a9671a"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#c87a1e"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -70.916 -70.425)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m67.729 78.037v2l1.1012-1.0002z",
  fill: "#a9671a"
}), /*#__PURE__*/React.createElement("path", {
  d: "m67.729 78.037v2l-1.1012-1.0002z",
  fill: "#a7a7a7"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -59.438 -69.741)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#a7a7a7"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#a9671a"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -70.333 -71.536)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#db8621"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#a9671a"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -61.617 -71.536)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#a9671a"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#db8621"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -59.438 -73.331)",
  fill: "#c87a1e"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m61.928 77.657v2l1.1012-1.0002z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -70.333 -67.946)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#c87a1e",
  opacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#db8621"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.9787 0 0 1.7949 -61.617 -67.946)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l1.1012-1.0002z",
  fill: "#db8621"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.535 77.656v2l-1.1012-1.0002z",
  fill: "#c87a1e",
  opacity: 1
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m65.275 71.441 2.1789 1.7946-0.0029-1.7946z",
  fill: "#404040",
  opacity: 0.8
}), /*#__PURE__*/React.createElement("path", {
  d: "m73.991 71.441-2.1789 1.7946 0.0029-1.7946z",
  fill: "#404040",
  opacity: 0.8
}), /*#__PURE__*/React.createElement("path", {
  d: "m65.275 75.031 2.1789 1.7946-2.1789-2e-6z",
  fill: "#ddd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m73.991 75.031-2.1789 1.7946 2.1789-2e-6z",
  fill: "#ddd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m76.17 73.236-2.1789 1.7946 2.1789-2e-6z",
  fill: "#c87a1e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m63.096 73.236 2.1789 1.7946-2.1789-2e-6z",
  fill: "#c87a1e"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#ddd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m63.096 75.031 2.1789 1.7953v-1.7946z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m65.275 76.825 2.1789 1.7953v-1.7946z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m76.17 75.03-2.1789 1.7953v-1.7946z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m73.991 76.825-2.1789 1.7953v-1.7946z"
})), /*#__PURE__*/React.createElement("path", {
  d: "m67.454 76.825 7e-6 1.7953h2.1789z",
  fill: "#a7a7a7"
}), /*#__PURE__*/React.createElement("path", {
  d: "m71.812 76.825-7e-6 1.7953h-2.1789z",
  fill: "#a7a7a7"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#ddd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m78.349 73.235-2.1789 1.7953v-1.7946z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m60.917 73.235 2.1789 1.7953v-1.7946z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m76.17 73.236 2.1789-6.83e-4 -9e-6 -1.7946z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m63.096 73.236-2.1789-6.83e-4 1e-5 -1.7946z"
}))));

function SvgVulpis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25.689 25.689",
    xmlns: "https://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vulpis web development logo in green circle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVulpis);
export default __webpack_public_path__ + "static/media/vulpis.c1e32581.svg";
export { ForwardRef as ReactComponent };